module.exports = "https://static.wmbcdn.com/uniweb/images/5ffce3c1df6b85641908f993c94a007d.svg";